module.exports = __webpack_public_path__ + "static/img/gpt15.e10ea85b.png";